import { IListItem, IMenuList } from '~/src/dash/types/menuList';

export const ALL_LANGUAGES = ['English', 'Spanish', 'French', 'Portuguese', 'German', 'Italian'];

export function getLanguagesAsIMenuList(selectedLanguages?: string[]): IMenuList {
  const out = {} as IMenuList;

  ALL_LANGUAGES.forEach((language, idx) => {
    out[idx] = {
      selected: selectedLanguages ? selectedLanguages.includes(language) : false,
      ID: idx.toLocaleString(),
      title: language,
    } as IListItem;
  });

  return out;
}
